/**
 * SelectNumberLayer
 * 수량 선택 레이어
 */
export default class SelectNumberLayer {
  constructor() {
    this.welContainer = $('#_layerContainer');
    this.sWrapper = '_selectNumberLayer';

    if ($(`#${this.sWrapper}`).length < 1) {
      this.render();
    }
  }

  render = () => {
    const sSelectNumberLayerTmpl = `
            <section  id="${this.sWrapper}" class="popup popup_layer select-number-list">
                <header class="popup_header">
                    <h3 class="popup_header_title">수량선택</h3>
                    <button type="button" class="popup_header_close" aria-label="팝업닫기" data-role="close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                            <path fill="#30343B" fill-rule="evenodd" d="M0 0h.87v.87H0V0zm.87.87h.87v.87H.87V.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87H20V20h-.87v-.87zM20 0v.87h-.87V0H20zm-.87.87v.87h-.87V.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-1.739 1.739v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869H1.74v-.87h.87zm-.869.869v.87H.87v-.87h.87zm-.87.87V20H0v-.87h.87z"></path>
                        </svg>

                    </button>
                </header>
                <div class="popup_contents">
                    <article class="popup_inner">
                        <ul></ul>
                    </article>
                </div>
            </section>
        `;

    this.welContainer.append(sSelectNumberLayerTmpl);
  };

  /**
   * 외부 호출에 의해 객체에 필요한 값을 설정하고 레이어를 엶
   * @param {object} htParams 레이어 사용에 필요한 값을 설정한 객체
   *  {{
   *      {object} targetEl 값을 표시/저장할 대상 엘리먼트 (생략 가능)
   *      {number} nCount 현재 선택된 수량
   *      {number} nBuyLimitMin 선택할 수 있는 최소 수량
   *      {number} nBuyLimitMax 선택할 수 있는 최대 수량
   *      {function} callBackFn 값이 선택되었을 때 실행할 함수 (생략 가능)
   *  }}
   */
  open = htParams => {
    if (htParams.targetEl) {
      this.targetEl = htParams.targetEl;
    } else {
      this.targetEl = null;
    }

    if (htParams.callBackFn) {
      this.callBackFn = htParams.callBackFn;
    } else {
      this.callBackFn = null;
    }

    this.renderOptions(htParams);

    // 레이어마다 this가 달라야하므로 eventListener를 지우고 등록
    this.clearEvent();
    this.setEvent();

    TMON.oApp.oUtil.handleOpenLayer({ welTargetLayer: $(`#${this.sWrapper}`) });
  };

  renderOptions(htParams) {
    if (!htParams.nBuyLimitMax) {
      return;
    }

    let sSelectItemsTmpl = '';
    for (
      let i = htParams.nBuyLimitMin || 1;
      i <= htParams.nBuyLimitMax;
      i += 1
    ) {
      const checked = htParams.nCount === i;
      sSelectItemsTmpl += `<li><input type="radio" id="ea${i}" name="count" class="${
        checked ? 'on' : ''
      }" value="${i}"><label for="ea${i}">${TMON.util.numberWithComma(
        i
      )}</label></li>`;
    }

    $(`#${this.sWrapper} ul`).html(sSelectItemsTmpl);
  }

  setEvent = () => {
    $(`#${this.sWrapper}`).on('change', '[name=count]', this.onChangeSelectNum);
  };

  clearEvent = () => {
    $(`#${this.sWrapper}`).off('change', '[name=count]');
  };

  onChangeSelectNum = () => {
    $(`#${this.sWrapper} [name=count]`).removeClass('on');

    const nVal = $(`#${this.sWrapper} [name=count]:checked`).val();

    if (this.targetEl) {
      this.targetEl.html(nVal);
      this.targetEl.attr('data-number', nVal);
    }

    if (typeof this.callBackFn === 'function') this.callBackFn(nVal);

    history.back();
  };
}
